// deleteMachineSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import { deleteMachine } from '@custom/rtk-apis/activeMachine/deleteActiveMachine';
import { initialState } from '@custom/constant';


const deleteMachineSlice = createSlice({
  name: "deleteMachineSlice",
  initialState,
  reducers: {
    resetdeletedmachineSlice(state) {
      state.status = ""; // Reset status when modal closes
      state.msg = "";    // Optionally reset message as well
      state.error = "";  // Reset error as well
    }
  },
  extraReducers: (builder) => {
    console.log("----------", builder);
    builder
      .addCase(deleteMachine.pending, (state) => {
        console.log("Pending");
        state.loading = true;
        state.error = ""; // Clear error on pending
      })
      .addCase(deleteMachine.fulfilled, (state, { payload }) => {
        console.log("Fulfilled", payload);
        state.loading = false;
        state.status = payload.status; // Assuming payload has a status field
        state.result = payload.result; // Set the result from the payload
        state.msg = payload.msg; // Set the message from the payload
      })
      .addCase(deleteMachine.rejected, (state, { error }) => {
        console.log("Rejected");
        state.loading = false;
        state.error = error.message; // Set error message on rejection
      });
  },
});

// Export the reducer and actions
export default deleteMachineSlice.reducer;
export const { resetdeletedmachineSlice } = deleteMachineSlice.actions;
